import { createApp } from "vue";
import Gruendertest from "./Gruendertest.vue";
import VueGtag from "vue-gtag";

createApp(Gruendertest)
    .use(VueGtag, {
        config: {
            id: "UA-12871462-4",
            params: {
                send_page_view: false,
            },
        },
    })
    .mount("#gruendertest");
